export const buildSolrUrl = (baseUrl, params = []) => {
    const endpoint = new URL(baseUrl, window.location.origin);

    params.forEach(([name, value]) => {
        if (value !== undefined && value !== null) {
            endpoint.searchParams.append(name, String(value));
        }
    });

    return endpoint.toString();
};
